import React from "react";
import Error from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/common/Error";

const SessionTimeoutCashiering = props => {
  return (
    <Error
      errorStatus={"440"}
      errorText={"OnePay Cashiering Session has expired"}
      errorDescription={
        "It looks like the OnePay Cashiering session has expired. Please close the tab and reopen the application."
      }
    />
  );
};

export default SessionTimeoutCashiering;
